import { ApiError, apiClient } from '../../../shared/api/base';
import { ArticleOnce } from '../config';

export async function getArticleOnceApi(slug: string) {
  try {
    return await apiClient<ArticleOnce>(`articles/${slug}`);
  } catch (error) {
    if (error instanceof ApiError && error.status === 404) return null;
    throw error;
  }
}
